import { sendTeacherAmplitudeEvent } from '~analytics/amplitude';
import { EventTypes } from '~analytics/types';

import { EventAdapter } from './EventAdapter';

type TrackedFeature =
  | 'invite_student_drawer'
  | 'share_room_dialog'
  | 'delivery_method_info'
  | 'import_roster'
  | 'add_students'
  | 'view_plan'
  | 'add_room'
  | 'clear_room'
  | 'new_account_page'
  | 'account_page_teams'
  | 'profile_page'
  | 'demographics_page'
  | 'see_all_plans'
  | 'ai_assisted_link'
  | 'prompt_learn_more_link'
  | 'ai_feedback_link'
  | 'invite_members_button'
  | 'plans_and_members_menu';

type TrackedAction = 'open' | 'close' | 'click';

interface FeatureUseEvent {
  feature: TrackedFeature;
  action: TrackedAction;
  source?: string;
}

interface ConstructorParams {
  feature: TrackedFeature;
  action: TrackedAction;
  source?: string;
}

export class FeatureUseEventAdapter extends EventAdapter {
  eventData: FeatureUseEvent;

  constructor({ feature, action, source }: ConstructorParams) {
    super();

    this.eventData = {
      feature: feature,
      action: action,
      ...(source && { source: source }),
    };
  }

  protected amplitudeEventFunction = function sendFeatureEvent(
    event: FeatureUseEvent
  ) {
    sendTeacherAmplitudeEvent(EventTypes.FeatureUse, event);
  };

  protected intercomEventKey = null;
}
